import { useEffect, useState } from 'react';

export function useDisplayMode() {
  const [displayMode, setDisplayMode] = useState<string>('browser tab');

  const listener = () => {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setDisplayMode('standalone');
    }
  };

  useEffect(() => {
    if (displayMode !== 'standalone' && window.matchMedia('(display-mode: standalone)').matches) {
      setDisplayMode('standalone');
    }
    window.addEventListener('DOMContentLoaded', listener);
    return () => {
      window.removeEventListener('DOMContentLoaded', listener);
    };
  }, [displayMode]);
  return displayMode;
}
